(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fixology-tracking"]) return;
  try {
    
(() => {
  let loader;
  function loadWidget() {
    if (window.YQV5?.trackSingle) return Promise.resolve();
    if (loader) return loader;
    loader = new Promise((resolve,reject) => {
      const script=document.createElement('script');
      const timer=setTimeout(()=>{script.remove();loader=undefined;reject(new Error('timeout'));},15000);
      script.src='https://www.17track.net/externalcall.js';script.async=true;
      script.onload=()=>{clearTimeout(timer);if(window.YQV5?.trackSingle)resolve();else{loader=undefined;reject(new Error('unavailable'));}};
      script.onerror=()=>{clearTimeout(timer);script.remove();loader=undefined;reject(new Error('unavailable'));};
      document.head.append(script);
    });
    return loader;
  }
  function init(root) {
    if(!root||root.dataset.ready)return;
    root.dataset.ready='true';
    const form=root.querySelector('form'),button=form.querySelector('button'),message=root.querySelector('[data-message]'),results=root.querySelector('[data-results]'),widget=root.querySelector('[data-widget]');
    const copy=root.querySelector('[data-copy]').content,loading=copy.querySelector('[data-loading]').textContent,error=copy.querySelector('[data-error]').textContent,buttonText=button.textContent;
    form.addEventListener('submit',async event=>{
      event.preventDefault();message.hidden=true;
      const input=form.elements.trackingNumber;input.value=input.value.trim();
      if(!form.reportValidity())return;
      const number=input.value.replace(/ /g,'');
      button.disabled=true;button.textContent=loading;
      try{
        await loadWidget();
        results.hidden=false;widget.replaceChildren();
        window.YQV5.trackSingle({YQ_ContainerId:widget.id,YQ_Height:560,YQ_Fc:'0',YQ_Lang:'en',YQ_Num:number});
        const frame=widget.querySelector('iframe');if(frame)frame.title='17TRACK shipment tracking results';
      }catch{results.hidden=true;message.textContent=error;message.hidden=false;}
      finally{button.disabled=false;button.textContent=buttonText;}
    });
  }
  document.querySelectorAll('[data-fx-parcel]').forEach(init);
  document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-fx-parcel]')));
})();

  } catch(e) { console.error(e); }
})();
})();
